import config from './config.service';
import { type Language, setupI18n as setupI18nService } from '@odin/services';
import Vue from 'vue';

const loadDefaultStrings = async (i18next: any) => {
  i18next.addResourceBundle('source', 'cart', await import('../assets/translations/source.json'));
};

export async function setupI18n() {
  const i18next = await setupI18nService({
    debug: config.env === 'development',
    language: config.language,
    supportedLanguages: [config.language, 'en-US', 'en-SE'],
    defaultNS: 'cart',
    loadLanguage: async (lang: Language) => {
      return (await import(`../assets/translations/app.${lang}.json`)).default;
    }
  });

  await loadDefaultStrings(i18next);

  Vue.use({
    install: (app: typeof Vue) => {
      app.prototype.$t = i18next.t;
      app.prototype.$n = (value: any, type: string) => {
        return app.prototype.$t(`number_format.${type}`, {
          val: value,
          formatParams: {
            val: {currency: config.currency},
          },
        });

      };
      app.prototype.$i18n = i18next;
    },
  });

  return i18next;
}
